// app/javascript/controllers/virtual_scroll_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["loadMoreRow", "loadingRow"]
    static values = {
        page: Number,
        perPage: Number,
        total: Number,
        alertId: Number
    }

    connect() {
        // Initialize the controller
        this.checkIfMoreToLoad()
    }

    loadMore(event) {
        event.preventDefault()

        // Show loading indicator
        this.loadMoreRowTarget.classList.add("hidden")
        this.loadingRowTarget.classList.remove("hidden")

        // Increment page
        this.pageValue++

        // Calculate offset
        const offset = (this.pageValue - 1) * this.perPageValue

        // Fetch more alerts
        fetch(`/reports/client_sent_alerts/${this.alertIdValue}/load_more?offset=${offset}&limit=${this.perPageValue}`, {
            headers: {
                "Accept": "text/vnd.turbo-stream.html",
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(response => response.text())
            .then(html => {
                // Process the Turbo Stream response
                Turbo.renderStreamMessage(html)

                // Hide loading indicator
                this.loadingRowTarget.classList.add("hidden")

                // Check if there are more alerts to load
                this.checkIfMoreToLoad()
            })
            .catch(error => {
                console.error("Error loading more alerts:", error)
                // Hide loading indicator and show load more button on error
                this.loadingRowTarget.classList.add("hidden")
                this.loadMoreRowTarget.classList.remove("hidden")
            })
    }

    checkIfMoreToLoad() {
        const loadedCount = (this.pageValue * this.perPageValue)

        // If we've loaded all alerts, hide the load more button
        if (loadedCount >= this.totalValue) {
            this.loadMoreRowTarget.classList.add("hidden")
        } else {
            this.loadMoreRowTarget.classList.remove("hidden")
        }
    }
}
